import { SET_DEPLOYMENTS, SET_HEARTBEATS, SET_DEPLOYMENT_CONFIG } from './actiontypes';
import {
  getDeployments,
  upsertDeployment,
  getDeploymentConfig,
  upsertDeploymentConfig,
  upsertDeploymentCollector,
  getAllHeartbeats,
  associateBuildings,
} from '../../api/Api';
import { sendData } from './util';

export const getDeploymentsAction = () => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return getDeployments(jwt).then((data) => dispatch(sendData(SET_DEPLOYMENTS, data)));
};

export const getHeartbeatsAction = () => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return getAllHeartbeats(jwt, '72h').then((data) => dispatch(sendData(SET_HEARTBEATS, data)));
};

export const getDeploymentConfigAction = (site) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return getDeploymentConfig(jwt, site).then((data) =>
    dispatch(sendData(SET_DEPLOYMENT_CONFIG, data))
  );
};

const DEPLOYMENT_READ_ONLY_FIELDS = ['device_ips', 'buildings', 'last_heartbeat'];

export const upsertDeploymentAction = (deployment) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  const payload = { ...deployment };
  DEPLOYMENT_READ_ONLY_FIELDS.forEach((f) => {
    delete payload[f];
  });
  return upsertDeployment(jwt, payload).then(() => dispatch(getDeploymentsAction()));
};

const COLLECTOR_READ_ONLY_FIELDS = [
  'site',
  'private_ip',
  'api_key',
  'device_ips',
  'wg_pubkey',
  'last_heartbeat',
];

export const upsertDeploymentCollectorAction = (collector) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  const payload = { ...collector };
  COLLECTOR_READ_ONLY_FIELDS.forEach((f) => {
    delete payload[f];
  });
  return upsertDeploymentCollector(jwt, collector.site, collector.private_ip, payload).then(() =>
    dispatch(getDeploymentConfigAction(collector.site))
  );
};

export const upsertDeploymentConfigAction = (site, config) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return upsertDeploymentConfig(jwt, site, config).then(() =>
    dispatch(getDeploymentConfigAction(site))
  );
};

export const associateBuildingsAction = (site, buildings) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return associateBuildings(jwt, site, buildings).then(() => dispatch(getDeploymentsAction()));
};
